module.exports = "https://static.wanderu.com/ui-react/_next/static/media/us.c95087e1.svg";